<template>
  <div class="yxtbiz-rule-condition">
    <!-- 条件 -->
    <template v-for="(item, index) in formData.listConditionDetail">
      <condition-item
        :ref="`cnd${index}`"
        :key="`cnd${index}`"
        :condition="item"
        :obj-list="objectList"
        :index="index"
        :platform-type="platformType"
        :custom-request-rule="customRequestRule"
        @delete="delCondition"
      ></condition-item>
    </template>
    <!-- 自定义条件规则 -->
    <div class="custom-rule">
      <yxt-form 
        ref="form"
        :model="formData"
        :rules="rules"
        label-width="0px"
      >
        <div>
          <yxt-button
            plain
            size='large'
            class="add-condition-btn"
            @click="addCondition"
          >
            <i class="mr10 yxt-icon-plus"></i>{{ $t('pc_biz_lbl_add_condition' /*'添加条件'*/)}}<label class="ml12 color-gray-7">{{ `(${cndCount}/10)` }}</label>
          </yxt-button>
        </div>
        <div v-if="customConditionRule" class="condition-wrap__ruler">
          <div class="customize-switch">
            <yxt-switch v-model="formData.conditionExpressionStatus" />
            <label class="ml16 color-gray-9">{{ $t('pc_biz_lbl_condition_run_rule' /* '具体条件运算规则' */) }}</label>
            <label class="switch-remark">{{ $t('pc_biz_lbl_run_rule_closed_remark' /* 运算规则关闭视为“并”的关系，即以上特征都需要满足 */)}}</label>
          </div>
          <!-- 自定义运算规则开启 -->
          <div v-if="formData.conditionExpressionStatus" class="ruler-set mt16">
            <yxt-radio-group
              v-model="formData.anyNumberConditionSwitch"
              :direction="'row'"
              class="width-percent-100"
              @change="onTypeChange"
            >
              <yxt-radio class="imp-width160" :label="1">
                <span>{{ $t('pc_biz_rule_reach_any_condition', [1]) /* 达到任意1个条件 */}}</span>
                <!-- <span class="mr14">{{ $t('pc_biz_reach_any'/* '达到任意' */) }}</span>
                <yxt-form-item prop="anyNumberCondition" class="is-special">
                  <yxt-input-number
                    class="mr8"
                    v-model="formData.anyNumberCondition"
                    :precision="0"
                    :min="1"
                    :max="formData.listConditionDetail.length || 1"
                  ></yxt-input-number>
                </yxt-form-item>
                <span>{{ $t('pc_biz_lbl_conditions' /* '个条件' */) }}</span> -->
              </yxt-radio>
              <yxt-radio :label="0">
                <span>{{ $t('pc_biz_rule_custom') /* 自定义 */ }}</span>
                <yxt-tooltip effect="light" placement="right">
                  <div class="customize-tooltip" slot="content" v-html="$t('pc_biz_rule_condition_remark')">
                    <!-- <p class="rule-remark">自定义：适用于复杂规则的编辑，当多个条件部分需要满足或指定条件满足时，可使用该编辑器</p>
                    <p class="example-title">举例</p>
                    <p>条件1：参与2门考试且成绩均达到合格</p>
                    <p>条件2：自主学习，完成3门课程学习</p>
                    <p>条件3：项目完成学习达到2个</p>
                    <p>若想达到：某学员参与2门考试且成绩均合格，自主学习3门课程或者完成2个项目的学习条件，可输入：<span class="rule-equation">1and(2or3)</span></p>
                    <p class="rule-character-remark">数字即条件的编号；and表示“且”的关系，即都要满足；or表示“或”的关系，即任一满足；</p>
                    <p class="rule-character-remark">表达式规范：只能使用数字、英文括号、and 和 or，不能有重复数字 ()——左括号和右括号必须成对出现，不区分大小写</p>-->
                  </div>
                  <yxt-svg class="ml4 mr8" width="16px" height="16px" icon-class="question-cirlce-o" />
                </yxt-tooltip>
                <yxt-form-item prop="conditionExpression" class="is-special custom-rule-width">
                  <yxt-input
                    v-model="formData.conditionExpression"
                    :disabled="!!formData.anyNumberConditionSwitch"
                    class="customize-input"
                    :placeholder="$t('pc_biz_rule_input_placeholder')"
                    maxlength="100"
                    show-word-limit
                  />
                </yxt-form-item>
              </yxt-radio>
            </yxt-radio-group>
          </div>
        </div>
      </yxt-form>
    </div>
  </div>
</template>

<script>
import { getRuleInfo, getRelatedObjList, checkExpression } from './service';
import ConditionItem from './component/ConditionItem.vue';
// 默认条件对象
const defaultCndData = {
  targetCode: '',
  moduleCode: '',
  actionCode: '',
  anyNumberAttr: 1, // 任意N个属性值
  anyNumberAttrSwitch: 1, // 任意N个条件开关，0：未开启，1：开启
  listConditionAttr: [],
  attrExpression: '',
  attrExpressionStatus: false, // 属性规则表达式状态：0-关闭，1-打开
  ruleConditionDetailId: null,
  sort: 1,
  deleted: 0,
  expend: true
};
export default {
  name: 'YxtbizRuleCondition',
  components: {
    ConditionItem
  },
  props: {
    // 业务编号
    businessCode: {
      type: String,
      default: ''
    },
    // 模块编号
    moduleCode: {
      type: String,
      default: ''
    },
    // 规则编号
    ruleCode: {
      type: String,
      default: ''
    },
    ruleData: {
      type: Object,
      default: () => {}
    },
    // 使用平台 op-运营平台
    platformType: {
      type: String,
      default: ''
    },
    // 支持多条件
    multi: {
      type: Boolean,
      default: true
    },
    // 支持自定义条件规则
    customConditionRule: {
      type: Boolean,
      default: false
    },
    // 支持自定义要求规则
    customRequestRule: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // const validCustomRuleCount = (rule, value, callback) => {
    //   if (!value && this.formData.anyNumberConditionSwitch === 1) {
    //     callback(new Error(this.$t('pc_biz_rule_please_enter_condition_count' /* '请输入达到任意条件的个数' */)));
    //   }
    //   callback();
    // };
    const validCustomRule = async(rule, value, callback) => {
      if (this.formData.conditionExpressionStatus && this.formData.anyNumberConditionSwitch === 0) {
        if (!value) {
          callback(new Error(this.$t('pc_biz_rule_please_enter_rule' /* '请输入自定义规则' */)));
        }
        const result = await checkExpression({expression: value, maxSort: this.cndCount }, this.platformType);
        if (!result) {
          callback(new Error(this.$t('pc_biz_rule_expression_error' /* '表达式错误' */)));
        }
      }
      callback();
    };
    return {
      formData: {
        conditionExpressionStatus: false, // 条件规则表达式状态 0:关闭 1:打开
        conditionExpression: '',
        anyNumberConditionSwitch: 1,
        anyNumberCondition: 1,
        listConditionDetail: [
          {...defaultCndData}
        ],
        id: ''
      },
      rules: {
        // 后期开放
        // anyNumberCondition: [{ validator: validCustomRuleCount.bind(this), trigger: ['blur', 'change']}],
        conditionExpression: [
          { validator: validCustomRule.bind(this), trigger: ['blur'] }
        ]
      },
      // 对象下拉集合
      objectList: []
    };
  },
  watch: {
    ruleCode(val) {
      console.log('ruleCode', val);
      if (val && !this.ruleData) {
        this.getRuleInfo();
      }
    },
    ruleData(val) {
      console.log('ruleData', val);
      if (val) {
        this.initData(val);
      }
    }
  },
  computed: {
    // 是否编辑状态
    isEdit() {
      return !!this.ruleCode;
    },
    // 已有条件数量
    cndCount() {
      return this.formData.listConditionDetail ? this.formData.listConditionDetail.length : 0;
    }
  },
  async mounted() {
    // 1、获取规则对象列表
    await this.getObjList();
    // 2、获取规则信息
    this.getRuleInfo();
    console.log('mounted');
  },
  methods: {
    async getObjList() {
      this.objectList = await getRelatedObjList({ businessCode: this.businessCode, moduleCode: this.moduleCode }, this.platformType);
    },
    /**
     * 获取已有的规则信息
     */
    getRuleInfo() {
      if (this.ruleData) {
        this.initData(this.ruleData);
      } else if (this.ruleCode) {
        getRuleInfo(this.ruleCode, this.platformType).then(res => {
          this.initData(res.condition);
        });
      }
    },
    initData(data) {
      if (!data) return;
      const conditionList = data.listConditionDetail
        ? data.listConditionDetail.map((i, index) => {
          return {
            ...i,
            expend: index === data.listConditionDetail.length - 1
          };
        }) : [];
      this.formData = {
        ...data,
        listConditionDetail: [...conditionList],
        conditionExpressionStatus: !!data.conditionExpressionStatus
      };
      console.log('formData', this.formData);
    },
    /**
     * 必填项校验
     */
    async validate() {
      try {
        const proList = [
          this.$refs.form.validate(),
          ...this.formData.listConditionDetail.map((item, index) => {
            console.log('refs', this.$refs, this.$refs[`cnd${index}`]);
            return this.$refs[`cnd${index}`][0].validate();
          })
        ];
        await Promise.all(proList);
        console.log('validate');
        return true;
      } catch (error) {
        console.log('invalid', error);
        return false;
      }
    },
    /**
     * 获取规则配置数据
     */
    getRules() {
      const conditions = this.formData.listConditionDetail.map((item, index) => {
        return {
          ...this.$refs[`cnd${index}`][0].getData(),
          sort: index + 1
        };
      });
      return {
        ...this.formData,
        conditionExpressionStatus: ~~this.formData.conditionExpressionStatus,
        listConditionDetail: conditions
      };
    },
    /**
     * 添加条件
     */
    addCondition() {
      this.validate().then(valid => {
        if (valid) {
          this.formData = this.getRules();
          if (this.formData.listConditionDetail) {
            this.formData.listConditionDetail = this.formData.listConditionDetail.map(item => {
              return {
                ...item,
                expend: false
              };
            });
          }
          this.formData.listConditionDetail.push({
            ...defaultCndData,
            sort: this.formData.listConditionDetail.length + 1
          });
        } else {
          this.$message.warning(this.$t('pc_biz_rule_please_complete_info' /* '请完善必填项' */));
        }
      });
    },
    /**
     * 删除条件
     */
    delCondition(index) {
      if (this.cndCount === 1) {
        this.$message.warning(this.$t('pc_biz_msg_at_least_one_condition' /* '请至少保留一个条件' */));
        return;
      }
      this.$confirm(this.$t('pc_biz_msg_delete_condition_comfirn' /* '条件删除后无法撤回，是否确认删除该条件？' */), this.$t('pc_biz_lbl_tip' /* '提示' */), {
        type: 'warning'
      }).then(() => {
        this.formData.listConditionDetail.splice(index, 1);
      });
    },
    /**
     * 处理自定义规则方式切换
     */
    onTypeChange(val) {
      if (val) {
        this.formData.conditionExpression = '';
      }
      this.$refs.form.clearValidate(['anyNumberCondition', 'conditionExpression']);
    }
  }
};
</script>
